export const onlyCpfDigits = (value?: string | null): string =>
  String(value ?? '').replace(/\D/g, '')
